module.exports = __webpack_public_path__ + "public/assets/img/logo_fff.f2258dc8.png";